export const MOBILE_FAB_SX = {
  position: "fixed",
  right: 16,
  bottom: "calc(16px + env(safe-area-inset-bottom))",
  zIndex: 1,
};
